import { Pencil, Minus, Plus } from 'lucide-react';
import ConfirmDeleteDialog from '@/components/ui/ConfirmDeleteDialog';
import React from 'react';
import Bar from '../../../../components/elements/Bar';
import List from '../../../../components/elements/List';

function TeamsDetailView({ data, makeEditable, addEmployee, removeEmployee, permission }) {
  if (!data) {
    return null;
  }

  const prepareDataDetail = () => {
    if (!data) return [];
    const { shortcut, title, leader_name } = data;
    return [
      { name: 'Označení', value: shortcut },
      { name: 'Název', value: title },
      { name: 'Vedoucí', value: leader_name },
    ];
  };

  const prepareDataMembers = () => {
    if (!data) return [];
    const { members_list } = data;
    return (members_list || []).map((ele) => ({
      name: ele?.employee_full_name,
      value: null,
      id: ele?.employee,
    }));
  };

  const deleteButton = (id) => (
    <ConfirmDeleteDialog
      title="Opravdu chcete odstranit zaměstnance?"
      onConfirm={() => removeEmployee(id)}
    >
      <Minus key={1} className="h-4 w-4" />
    </ConfirmDeleteDialog>
  );
  return (
    <div className="w-full overflow-y-auto">
      <Bar
        text={'Detail týmu'}
        content={
          permission === 2
            ? [
                <Pencil
                  key={1}
                  className="h-4 w-4"
                  data-testid="teams-detail-edit-btn"
                  onClick={makeEditable}
                />,
              ]
            : []
        }
      />
      <List data={prepareDataDetail()} />
      <Bar
        text={'Osoby v týmu'}
        content={
          permission === 2
            ? [
                <Plus
                  key={1}
                  className="h-4 w-4"
                  data-testid="teams-detail-add-member-btn"
                  onClick={addEmployee}
                />,
              ]
            : []
        }
      />
      <List data={prepareDataMembers()} actions={[deleteButton]} />
    </div>
  );
}

export default TeamsDetailView;
